import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"
import { formatItemForCart } from "src/main/PointOfSale/utils"

import { formattedDollars } from "src/utils/UnitConversion"

const PosItemCard = ({ item, transaction, onClick }) => {
  const { presentmentCurrency, fuelMeasurementUnitSymbol } = useMarina()
  const formattedItem = formatItemForCart(item)
  const pricePerUnit = formattedDollars(
    formattedItem?.price,
    2,
    presentmentCurrency
  )
  const totalPrice = formattedDollars(
    transaction?.volume * formattedItem?.price,
    2,
    presentmentCurrency
  )

  return (
    <div
      onClick={onClick}
      className="hover:bg-gray-50 flex cursor-pointer items-center justify-between rounded-lg border border-gray-200 p-4 transition-colors"
    >
      <div className="space-y-1">
        <div className="font-medium text-gray-900">{item.name}</div>
        <div className="text-sm text-gray-500">{item.description}</div>
      </div>
      <div className="text-lg font-semibold text-gray-900">
        {pricePerUnit} / {fuelMeasurementUnitSymbol} | {totalPrice}
      </div>
    </div>
  )
}

PosItemCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
  transaction: PropTypes.shape({
    volume: PropTypes.number.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default PosItemCard
